<template>
  <div class="datepicker">
    <label for="for-date">{{ label }}</label>
    <DatePicker
      label="Date input"
      id="for-date"
      v-model="date"
      fluid
      showIcon
      variant="filled"
      iconDisplay="input"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DatePicker from 'primevue/datepicker';

const emit = defineEmits(['update:value']);
const props = defineProps({
  label: { type: String, default: '' },
  modelValue: { type: [Date, String], default: '' },
});

const date = computed({
  get: () => props.modelValue,
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped lang="scss">
.datepicker {
  text-align: left;

  :deep(.p-datepicker-input) {
    border-radius: 4px !important;
    background-color: #f3f3f3 !important;
    border: 2px solid #cdcdcd;

    &:focus {
      border-color: $AC_Black;
    }
  }
}
</style>
